module.exports = __webpack_public_path__ + "fonts/mulish-v11-latin-italic.dac0777.ttf";